export default "__VITE_ASSET__B_3m2pH4__"